import { createClient } from "@supabase/supabase-js"
import type { Database } from "@/shared/types/database.types"

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Fail fast if environment variables are not configured
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "Supabase environment variables are not configured. " +
      "Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your .env file. " +
      "See .env.example for reference or check the Supabase setup documentation.",
  )
}

// Create Supabase client
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
  },
})
